import React from "react";
import PropTypes from 'prop-types';
import Link from './Link';

export default class LinksColumn extends React.PureComponent {
    renderLinks = (links) => {
        return links.map((elem, index) => {
            const onClick = typeof elem.onClick === 'function' ? elem.onClick : null;
            return <Link onClick={onClick} link={elem.url} text={elem.text} isInternal={elem.isInternal} key={index}/>
        });
    };
    render() {
        let { type, links } = this.props;

        return (
            <div className={'links-column ' + type}>
                {this.renderLinks(links)}
            </div>
        );
    }
}

LinksColumn.propTypes = {
    type: PropTypes.string.isRequired,
    links: PropTypes.array,
};

